/* BIA price normaliser.
   The store money format is "Rs.{{amount}}", which renders as "Rs.28,000.00".
   BIA's house style is "Rs 28,000". Rather than change the global currency
   format (which would also affect the live theme) or rewrite vendor snippets,
   this normalises the DISPLAY STRING only. No value is changed and nothing is
   recalculated — the cart, checkout and Shopify totals are untouched.
   Runs on load, on mutation, on interaction and on a short settle timer,
   because parts of the search and cart UI mount asynchronously. */
(function () {
  var RE = /^\s*Rs\.?\s?([\d,]+)(\.00)?\s*$/;
  var SEL = [
    '.price',
    '.pc__p',
    '.qa__p',
    '.bp__price',
    '.bp__stickyp',
    '.swp__price',
    '.brel .pc__p',
    '[ref="priceContainer"] span',
    '.cart-item__price',
    '.totals__subtotal-value'
  ].join(',');

  /* Idempotent by comparison, not by a one-shot flag.

     The earlier version marked each element with a dataset flag and skipped it
     forever after. That broke on product pages: the product section's own
     variant script rewrites [data-bp-price] from shop.money_format whenever a
     colour or size changes, putting "Rs.22,000" back after we had already
     marked the element as done. Whichever script happened to run last won, so
     the dotted format reappeared intermittently.

     Comparing against the desired string instead means we re-normalise after
     any re-render, and we only write when the text actually differs — so the
     MutationObserver below cannot trigger itself. */
  function fix(el) {
    if (!el) return;
    var t = el.textContent;
    var m = t && t.match(RE);
    if (!m) return;
    var next = 'Rs ' + m[1];
    if (t === next) return;
    el.textContent = next;
  }

  function sweep(scope) {
    var s = scope && scope.querySelectorAll ? scope : document;
    s.querySelectorAll(SEL).forEach(fix);
    document.querySelectorAll('template').forEach(function (t) {
      if (t.content) t.content.querySelectorAll('.price').forEach(fix);
    });
  }

  function start() {
    sweep();
    [200, 700, 1600].forEach(function (ms) { setTimeout(function () { sweep(); }, ms); });
    document.addEventListener('click', function () { setTimeout(sweep, 80); }, true);
    document.addEventListener('change', function () { setTimeout(sweep, 80); }, true);
    /* Theme editor re-renders a section without a page load. */
    document.addEventListener('shopify:section:load', function () { setTimeout(sweep, 60); });

    if (!('MutationObserver' in window)) return;
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = requestAnimationFrame(function () { pending = null; sweep(); });
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
